module.exports = __webpack_public_path__ + "static/media/CELULAR.d0769fc9.png";